import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_BASE, API_PATH } from './constants';
import {
  DEFAULT_COMPANY_DOCUMENTS,
  DEFAULT_EMPLOYEE_DOCUMENTS,
} from './fixtures';

export const documentsHandlers = [
  http.get(`${API_BASE}/${API_PATH}?userId=:userId&documentType=document`, () =>
    HttpResponse.json(DEFAULT_EMPLOYEE_DOCUMENTS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(
    `${API_BASE}/${API_PATH}?companyId=:companyId&documentType=document`,
    () =>
      HttpResponse.json(DEFAULT_COMPANY_DOCUMENTS, {
        status: HTTPStatusCodes.OK,
      }),
  ),
];
